import React, { useEffect, useState } from 'react';
import close_button from '../../../assets/close_button.png';
import FcModuleStyle from '../styles/fc.module.css';
import Highcharts from 'highcharts';
require('highcharts/modules/accessibility')(Highcharts);
//require('highcharts/modules/mouse-wheel-zoom.js')(Highcharts);

const TrackingGraph = ({ type, isDecisionPopup, showDecisionPopupHandler, hideDecisionPopupHandler, simObj, setSimObj, isResult, summaryGraphData, attempt }) => {
  const [gGraphStyle, setGGraphStyle] = useState({ left: 0, top: 0 });
  const [monthlydata, setMonthlyData] = useState('');
  const [RevenueData, setRevenueData] = useState({ "monthly": [], "quarterly": [], "yearly": [] });
  const [CostsData, setCostsData] = useState({ "monthly": [], "quarterly": [], "yearly": [] });
  const [APERangeData, setTrackingData] = useState({ "REGULAR": [], "MIDGRADE": [], "PREMIUM": [] });
  const [xAxisMinMax, setXAxisMinMax] = useState({ "monthly": { min: 1, max: 31 }, "quarterly": { min: 0, max: 3 }, "yearly": { min: 0, max: 12 } });
  const [dpObject, setDpObject] = useState({});
  const [isShowD, setIsShowD] = useState(true);
  const [revenueGraphLabel, setRevenueGraphLabel] = useState("");
  const [chart, setChart] = useState(null);
  const [isOptionsUpdated,setIsOptionsUpdated] = useState(false)
  const [isStyleTagPresent, setIsStyleTagPresent] = useState(false); //Added for stylus tool text-spacing change OM-620


  let graphSettings = {}
  function getMonthDays(year, month) {
    // Months are 0-based in JavaScript (0 - January, 1 - February, ..., 11 - December)
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
  }
  const getDate = (date) => {
    let formattedDate;
    let dateObject = new Date(date);
    let options = { year: 'numeric', month: 'long'};
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      dateObject = new Date(date.replace(/-/g, "/"));
    }
    return dateObject.toLocaleDateString(navigator.language, options);
  }
 
  const setGraphData = () => {
    if (chart != undefined) {
      let RegularTrackingSig;
      let MidgradeTrackingSig;
      let PremiumTrackingSig;
      (chart && chart?.yAxis && chart?.yAxis[0]) && chart?.yAxis[0]?.update({ min: -50, max: 100 });
      //Regular Tracking Signal

      RegularTrackingSig = simObj?.graphdata;
      RegularTrackingSig = (RegularTrackingSig != undefined ? RegularTrackingSig : []).map((data) => {
        return {
          x: data?.cr,
          y: data?.fi?.REGULAR?.trackingSignal,
          date: getDate(data.cd).replace("1,", " ").replace(/\s+/g, ' '),
          RegulartrackingSignal:data?.fi?.REGULAR?.trackingSignal
        }
      });
      RegularTrackingSig.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      setTrackingData(prevData => ({
        ...prevData,
        REGULAR: RegularTrackingSig,
      }));

      if (RegularTrackingSig.length != (chart?.series && Array.isArray(chart.series) && chart?.series[0]?.data?.length)) {
        chart?.series && Array.isArray(chart.series) && chart?.series[0]?.setData(RegularTrackingSig);
      }

      if(simObj?.optionsAvailable?.MIDGRADE){
      //Midgrade Tracking Signal
      MidgradeTrackingSig = simObj?.graphdata;
      MidgradeTrackingSig = (MidgradeTrackingSig != undefined ? MidgradeTrackingSig : []).map((data) => {
        return {
          x: data?.cr,
          y: data?.fi?.MIDGRADE?.trackingSignal,
          date: getDate(data.cd).replace("1,", " ").replace(/\s+/g, ' '),
          MidgradertrackingSignal:data?.fi?.MIDGRADE?.trackingSignal
        }
      });
      MidgradeTrackingSig.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      setTrackingData(prevData => ({
        ...prevData,
        MIDGRADE: MidgradeTrackingSig,
      }));
      if (MidgradeTrackingSig.length != (chart?.series && Array.isArray(chart.series) && chart?.series[2]?.data?.length)) {
        chart?.series && Array.isArray(chart.series) && chart?.series[1]?.setData(MidgradeTrackingSig);
      }
    }

    if(simObj?.optionsAvailable?.PREMIUM){
      //Premium Tracking Signal
      PremiumTrackingSig = simObj?.graphdata;
      PremiumTrackingSig = (PremiumTrackingSig != undefined ? PremiumTrackingSig : []).map((data) => {
        return {
          x: data?.cr,
          y: data?.fi?.PREMIUM?.trackingSignal,
          date: getDate(data.cd).replace("1,", " ").replace(/\s+/g, ' '),
          PremiumtrackingSignal:data?.fi?.PREMIUM?.trackingSignal
        }
      });
      PremiumTrackingSig.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      });
      setTrackingData(prevData => ({
        ...prevData,
        PREMIUM: PremiumTrackingSig,
      }));
      if (PremiumTrackingSig.length != (chart?.series && Array.isArray(chart.series) && chart?.series[4]?.data?.length)) {
        chart?.series && Array.isArray(chart.series) && chart?.series[2]?.setData(PremiumTrackingSig);
      }
    }
  }
    (simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && (chart && chart?.yAxis && chart?.yAxis[0]) && chart?.yAxis[0].update({ min: -50, max: 100 })
  }

  function getLevelsText(simObj) {
    const levels = [];
    if (simObj?.optionsAvailable?.REGULAR) levels.push("Regular");
    if (simObj?.optionsAvailable?.MIDGRADE) levels.push("Midgrade");
    if (simObj?.optionsAvailable?.PREMIUM) levels.push("Premium");

    if (levels.length === 0) return "";

    if (levels.length === 2) return `${levels[0]} and ${levels[1]}`;
    if (levels.length > 2) {
      return levels.slice(0, -1).join(", ") + " and " + levels.slice(-1);
    }
    return levels[0];
  }
  const applyChartAccessibility = (chart) => {
    if (chart && chart.renderTo) {
      const svg = chart.renderTo.querySelector('svg');
      if (svg) {
        setTimeout(() => {
        const levelsText = getLevelsText(simObj);
        svg.setAttribute('role', 'img');
        svg.setAttribute(
          'aria-label',
          `Tracking Signal line chart comparing ${levelsText} signals across months`
        );
        // remove old desc if exists
        const oldDesc = svg.querySelector('desc');
        if (oldDesc) oldDesc.remove();
        // add new desc
        const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
        desc.textContent =
          `This chart shows the tracking signal percentage for  ${levelsText} from January to December.`;
        svg.insertBefore(desc, svg.firstChild);
        }, 0);
      }
    }
  }

  // const regularTracking = [5, 3, 4, 3, 2, 6, 4, 5, 3, 2, 4, 3, 3, 3, 4, 3, 2, 6, 4, 5, 3, 2, 4, 3];
  // const midgradeTracking = [2, 4, 5, 4, 3, 7, 5, 6, 4, 3, 5, 4, 4, 4, 5, 4, 3, 7, 5, 6, 4, 3, 5, 4];
  // const premiumTracking = [7, 5, 6, 5, 4, 8, 6, 7, 5, 4, 6, 5, 5, 5, 6, 5, 4, 8, 6, 7, 5, 4, 6, 5];
  
  let seriesData = {
    "REGULAR" : {
      name: "Regular - Tracking Signal",
      borderWidth: 1,
      borderRadius: 0,
      states: {
        hover: {
          borderWidth: 1, // Border width on hover
          borderColor: 'black' // Border color on hover
        }
      },
      data: [],
      color: "#044E61",

    },
    "MIDGRADE": {
      name: "Midgrade - Tracking Signal",
      borderWidth: 1,
      borderRadius: 0,
      crisp: true,
      states: {
        hover: {
          borderWidth: 1, // Border width on hover
          borderColor: 'black' // Border color on hover
        }
      },
      data: [],
      color: "#1A83CF",

    },
    "PREMIUM": {
      name: "Premium - Tracking Signal",
      borderWidth: 1,
      borderRadius: 0,
      crisp: true,
      states: {
        hover: {
          borderWidth: 1, // Border width on hover
          borderColor: 'black' // Border color on hover
        }
      },
      data: [],
      color: "#069161",

    }
  }
  graphSettings = {
    plotOptions: {
      line: {
        fillColor: {
          pattern: {
            path: {
              d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
              strokeWidth: 3
            },
            width: 10,
            height: 10,
            opacity: 0.4
          }
        }
      },
      // events: {
      //   legendItemClick: function () {
      //     return false; // Prevent default legend item click behavior
      //   }
      // },
      series: {
        //stickyTracking: false,
        marker: {
          enabled: true,
        },
        pointPlacement: "on",
        dataLabels: {
          enabled: false,
          },
          events: {
            legendItemClick: function () {
              // debugger;
              let min = this?.chart?.series[2].yAxis.min && this?.chart?.series[2].yAxis.min;
              let max = this?.chart?.series[2].yAxis.max && this?.chart?.series[2].yAxis.max;
              setTimeout(() => {
                (this?.chart?.series && this.chart.series.every(series => !series.visible)) ? (this?.chart && this?.chart?.yAxis && this?.chart?.yAxis[0]) && this?.chart?.yAxis[0].update({ min: min, max: max }) : (this?.chart && this?.chart?.yAxis && this?.chart?.yAxis[0]) && this?.chart?.yAxis[0].update({ min: undefined, max: undefined, tickInterval: null });
              }, 100);
            }
          },
        },
        states: {
          inactive: {
            enabled: false
            //opacity:1
          },
        },
    },
    chart: {
      type: "line",
      responsive: false,
      //marginRight: 15,
      // marginTop: 3,
      height: 280,
      marginBottom: 120,
      plotBorderWidth: 1,
      panning: type === "quarterly",
      events: {
        render: function () {
          applyChartAccessibility(this);
        },
        redraw: function () {
          applyChartAccessibility(this);
        }
      }
    },
    title: null,
    legend: {
      enabled: true,
      align: "center",
      verticalAlign: "bottom",
      layout: 'horizontal',
      floating: true,
      visible: true,
      y: -10,
    },
    xAxis: {
      min: 1,
      max: 24,
      categories: ['','Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      step: 1,
      //gridLineWidth: 1.5,
      tickInterval: 1,
      tickLength: 0,
      lineColor: '#C6C6C3',
      title: {
        text: "Month Range",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        },
      },
      labels: {
        rotation: -45,
        step: 1,
        style: {
          fontSize: '0.8em'
        }
      },
      crosshair: {
        width: 1,
        color: '#C9C8B9'
      }
    },
    yAxis:{ // Secondary yAxis
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 4,
      //allowDecimals: false,
      gridLineColor: '#C6C6C3',
      gridLineWidth: 1,

      title: {
        text: "Tracking",
        style: {
          fontWeight: 'bold',
          fontSize: '10px',
          color: "#000"
        }
      },
      labels: {
          //format: '{value} mm',
          format:'{value}%',
      }

  },
    accessibility: {
      enabled: true,
      description: 'Tracking Signal line chart with percentage values across months.',
      pointDescriptionFormatter: function (point) {
        // Customize the aria-label for each point
        return `Date: ${point.date}; ${(point.RegulartrackingSignal != undefined) ? `Regular Tracking Signal: ${point.RegulartrackingSignal}%;` : ``} ${(point.MidgradertrackingSignal != undefined) ? `Midgrade Tracking Signal: ${point.MidgradertrackingSignal}%;` : ``} ${(point.PremiumtrackingSignal != undefined) ? `Premium Tracking Signal: ${point.PremiumtrackingSignal}%;` : ``}`;
      },
      keyboardNavigation: {
        enabled: true, // Enable keyboard navigation
      }, 
      screenReaderSection: {
          beforeChartFormat: '' // disables the default label
      }
    },
    credits: {
      enabled: false
    },
    series: undefined,
    tooltip: {
      hideDelay: 0,
      shared: true,
      formatter: function () {
        return '<strong>' + (this.point.date) + '</strong><br/>' +
        this.points.map(point => '<span style="color:' + point.color + ';">●</span> ' + point.series.name + ': <strong>' + point.y +'%' + '</strong>').join('<br>');
      },
      /*borderWidth: 1,
      formatter: function () {
        var tooltipText = '<strong>' + (this.point.date) + '</strong><br/>';
        if (this.series.name === 'Regular - Tracking Signal') {
          tooltipText += '<span style="color:' + this.point.color + ';">● </span>' + this.series.name + ': <strong style="font-weight: bold;">' + this.y +'%' + '</strong>';
        } else if (this.series.name === 'Midgrade - Tracking Signal') {
          tooltipText += '<span style="color:' + this.point.color + ';">● </span>' + this.series.name + ': <strong style="font-weight: bold;">' + this.y +'%' + '</strong>';
        } else if (this.series.name === 'Premium - Tracking Signal') {
          tooltipText += '<span style="color:' + this.point.color + ';">● </span>' + this.series.name + ': <strong style="font-weight: bold;">' + this.y +'%' + '</strong>';
        }
        return tooltipText;
      }*/
    }

  }


  useEffect(() => {
    if(type && simObj?.optionsAvailable && !isOptionsUpdated){
      let seriesdata = []
      for (const key in simObj?.optionsAvailable) {
        if (simObj?.optionsAvailable[key]) {
          seriesdata = [...seriesdata,seriesData[key]]
        }
      }
    graphSettings.series = seriesdata
    const newChart = Highcharts.chart("TrackingSignal", graphSettings);
    setChart(newChart);
    // if (type === "monthly" || type === "quarterly" || type === "yearly") {
    //   const g_container = FcModuleStyle['graph-container'];
    //   let gContainer = document.getElementsByClassName(`${g_container}`)[1];
    //   gContainer.setAttribute("tabindex", '-1');
    //   gContainer.focus();
    // }
    //Added for xaxis type quarterly resizable.
    if (type === "quarterly") {
      function updateCategories(type) {
        const categories = type === "quarterly" ?
          (window.innerWidth < 1218 ?
            ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'] :
            ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']) :
          [];
        if (newChart && newChart.xAxis && newChart.xAxis[0]) {
          newChart.xAxis[0].update({
            categories: categories
          });
        }
      }
      updateCategories("quarterly");
      window.addEventListener('resize', function () {
        updateCategories("quarterly");
      });
    }
    setIsOptionsUpdated(true);
  }
  }, [type,simObj?.optionsAvailable]);

  useEffect(() => {
    if (isResult && chart != undefined) {
      // chart?.series[0]?.setData([]);
      // chart?.series[1]?.setData([]);
      setSimObj((prevObj) => ({
        ...prevObj,
        graphdata: summaryGraphData,
      }));
    }
    else {
      setGraphData();
    }
    if (chart != undefined) {
      setRevenueGraphLabel(`Revenue and Cost of quality graph representing along Y-axis with ${chart?.yAxis != undefined && chart?.yAxis[0].tickInterval}% per unit scale and Time quarter along X-axis with 1 quarter per unit scale.`);
      document.querySelector("#TrackingSignal").setAttribute('role', `figure`);
      document.querySelector("#TrackingSignal .highcharts-container ").setAttribute('tabindex', '0');
    }
  }, [chart, simObj?.graphdata]);
  useEffect(() => {
    if (isResult) {
      //setGraphData();
    }
  }, [simObj, isResult, summaryGraphData])
 
  useEffect(() => {
    const checkStyleTag = () => {
      const styleTag = document.querySelector('style.stylus');
      setIsStyleTagPresent(!!styleTag);  // Updates the state to true if the tag is found, false otherwise
    };

    // Call the check function when the component mounts
    checkStyleTag();

    // Optionally, if the tag might be dynamically added, use a MutationObserver or setInterval
    const intervalId = setInterval(checkStyleTag, 500); // Check every 500ms
    return () => clearInterval(intervalId);  // Clean up interval when component unmounts
  }, []);
  useEffect(()=>{
    if(chart != undefined){
      // Update the legend dynamically
      chart.update({
        legend: {
            itemStyle: {
                fontSize: isStyleTagPresent ? '0.7em' : '0.8em',
            },
        },
    });
    }
  },[chart,isStyleTagPresent])

  return (
    <div className={`${FcModuleStyle['graph-container']}`}>
      {!simObj?.graphdata?.length && <div className={`${FcModuleStyle['nodata-alert-TrackingSignal']}`}>Tracking Signal will appear here as the simulation runs</div>}
      <span></span>
      {/* <a href="#" onClick={(e)=> e.preventDefault()} aria-label="Legends: line with round bullet for Revenue and line with Rhombus got Cost of Quality" className="sr-only"></a> */}
      <div id="TrackingSignal" className={`${FcModuleStyle['revenue-graph']}`} aria-label={revenueGraphLabel} role='figure'>
      </div>
    </div>
  )
}

export default TrackingGraph